import { render, staticRenderFns } from "./installation_method.vue.js?vue&type=template&id=1c6060f0!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./installation_method.vue?vue&type=template&id=1c6060f0"
import script from "./installation_method.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./installation_method.vue?vue&type=script&lang=js"
export * from "./installation_method.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./installation_method.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports